// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__I4qNQ","list":"styles_list__k1umP"};